import React, { useEffect } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

/**
 * Legacy `/checkout` entry point.
 *
 * The pre-Location-terminology purchase page shown here used to hard-code
 * "Growth Plan / Outlets" and hit the legacy `/api/billing/checkout`
 * endpoint. The canonical initial-purchase flow now lives on `/pricing`
 * (with the `OrderReviewModal` doing "Review your order" → Stripe
 * Checkout via `POST /api/subscriptions/checkout`).
 *
 * We redirect here instead of rendering to guarantee no stale plan/price
 * ever appears in the buyer journey — even from a bookmark, direct link
 * or copy-pasted URL. Any `plan` / `cycle` query params are preserved so
 * downstream callers can still deep-link the buyer into the review flow.
 */
export default function CheckoutPage() {
  const [params] = useSearchParams();
  const qs = params.toString();

  // Best-effort: also clear the historical `pending_plan` local-storage
  // key (still read by AuthPage / VerifyEmailPage for backward
  // compatibility) so no legacy Growth-Plan intent can rehydrate.
  useEffect(() => {
    try { localStorage.removeItem('pending_plan'); } catch { /* noop */ }
  }, []);

  return <Navigate to={qs ? `/pricing?${qs}` : '/pricing'} replace />;
}
